<div *kienePermission="[1291]" style="padding: 24px">
    <mat-card [attr.data-cy]="'maiai_mat-card_1_11_'">
        <div class="one-row">
            <h1 [attr.data-cy]="'maiai_h1_1_4_'">Indikationen</h1>
            <span class="spacer" [attr.data-cy]="'maiai_span_1_16_'"></span>
            <div class="one-row">
                <span class="spacer" [attr.data-cy]="'maiai_span_2_16_'"></span>
                <button
                    *kienePermission="[1293]"
                    mat-icon-button
                    color="accent"
                    (click)="add()"
                    [attr.data-cy]="'maiai_button_1_0_'"
                >
                    <mat-icon [attr.data-cy]="'maiai_mat-icon_1_2_'">add</mat-icon>
                </button>
                <button mat-icon-button color="accent" (click)="reload()" [attr.data-cy]="'maiai_button_2_0_'">
                    <mat-icon [attr.data-cy]="'maiai_mat-icon_2_2_'">refresh</mat-icon>
                </button>
            </div>
        </div>

        <ul
            class="draggable-table"
            style="list-style-type: none; padding: 0; margin: 0"
            cdkDropList
            (cdkDropListDropped)="reorderList($event)"
        >
            <li
                class="draggable-row"
                *ngFor="let i of indikationen; let id = index"
                cdkDrag
                [attr.data-cy]="'maiai_li_1_17_' + id"
            >
                <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                <div class="one-row">
                    <p style="width: 34%">{{ i.diagnose }}</p>
                    <p style="width: 33%">{{ i.sortierung }}</p>
                    <div style="width: 28%">
                        <ul style="list-style-type: disc">
                            <li
                                *ngFor="let t of i?.tierarten; let it = index"
                                [attr.data-cy]="'maiai_li_2_17_' + id + '_' + it"
                            >
                                {{ t.tierart }}
                            </li>
                        </ul>
                    </div>
                    <button
                        mat-icon-button
                        [matMenuTriggerFor]="menu"
                        aria-label="Indikation Menu"
                        [attr.data-cy]="'maiai_button_3_0_' + id"
                    >
                        <mat-icon [attr.data-cy]="'maiai_mat-icon_3_2_' + id">more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button
                            *kienePermission="[1293]"
                            mat-menu-item
                            (click)="openIndikationDialog(i)"
                            [attr.data-cy]="'maiai_button_4_0_' + id"
                        >
                            <mat-icon [attr.data-cy]="'maiai_mat-icon_4_2_' + id">edit</mat-icon>
                            <span [attr.data-cy]="'maiai_span_3_16_' + id">Bearbeiten</span>
                        </button>

                        <button
                            *kienePermission="[1294]"
                            mat-menu-item
                            (click)="openDeleteDialog(i)"
                            [attr.data-cy]="'maiai_button_5_0_' + id"
                        >
                            <mat-icon [attr.data-cy]="'maiai_mat-icon_5_2_' + id">delete</mat-icon>
                            <span [attr.data-cy]="'maiai_span_4_16_' + id">L&ouml;schen</span>
                        </button>
                    </mat-menu>
                </div>
            </li>
        </ul>
    </mat-card>
</div>
